import houseApi from "@/api/houseApi"
import UseSearchString from "@/composables/UseSearchString"

export default {
  namespaced: true,
  state: {
    houses: {
      previousPageLink: undefined,
      nextPageLink: undefined,
      countHouses: undefined,
      list: []
    },
    housesSearchResult: {
      previousPageLink: undefined,
      nextPageLink: undefined,
      countHouses: undefined,
      list: []
    },

    listLoadingStatus: false,
    searchInput: undefined,
    currentPage: undefined,
    countHousesOnPageValues: [5, 10, 20],
    allPassportsCoordinates: []
  },
  getters: {
    coordinatesList: state =>  state.allPassportsCoordinates.map(i => ({
        coordinates: [i.house.lat, i.house.lon],
        id: i.id,
        address: i.house.address
      })),
    getHouseById: state => id => state.houses.list.find(i => i.id === id),
    getHousesList(state, getters, rootState) {
      let resultList
      if (state.searchInput) {
        resultList = {
          ...state.housesSearchResult,
          list: state.housesSearchResult.list.map(i => ({
            ...i,
            kadastr: UseSearchString.fillSearchResult(i.kadastr, state.searchInput),
            house: {
              ...i.house,
              address: UseSearchString.fillSearchResult(i.house.address, state.searchInput)
            }
          }))
        }
      } else {
        resultList = state.houses
      }

      resultList = {
        ...resultList,
        countPages: Math.ceil(resultList.countHouses / rootState.countHousesOnPage.countHousesOnPage),
      }

      const currentPageNumber = state.currentPage || 1,
        countPages = resultList.countPages,
        paginator = {currentPageNumber, pages: []}

      if (countPages > 1 && resultList.list) {

        for (let i = -2; i <= 2; i++) {
          paginator.pages.push(currentPageNumber + i)
        }

        paginator.pages = paginator.pages.filter(i => i > 0 && i <= countPages)

        if (paginator.pages[0] - 2 > 0) {
          paginator.pages = [1, '...', ...paginator.pages]
        }

        if (paginator.pages[paginator.pages.length - 1] + 2 <= countPages) {
          paginator.pages = [...paginator.pages, '...', countPages]
        }

      }

      return {...resultList, paginator}
    }
  },
  mutations: {
    setHousesList(state, payload) {
      state.houses.list = payload.results
      state.houses.nextPageLink = payload.next || undefined
      state.houses.countHouses = payload.count || undefined
      state.houses.previousPageLink = payload.previous || undefined
    },
    setSearchHousesList(state, payload) {
      state.housesSearchResult.list = payload.results
      state.housesSearchResult.nextPageLink = payload.next || undefined
      state.housesSearchResult.countHouses = payload.count || undefined
      state.housesSearchResult.previousPageLink = payload.previous || undefined
    },
    setLoadingStatus(state, payload) {
      state.listLoadingStatus = payload
    },
    setSearchInput(state, payload) {
      state.searchInput = payload
    },
    clearSearch(state) {
      state.searchInput = undefined
      state.housesSearchResult.list = []
      state.housesSearchResult.nextPageLink = undefined
      state.housesSearchResult.previousPageLink = undefined
    },
    setCurrentPage(state, payload) {
      state.currentPage = payload
    },
    setAllPassportsCoordinates(state, payload) {
      state.allPassportsCoordinates = payload
    }
  },
  actions: {
    loadHousesList({state, commit, rootState, dispatch}) {
      dispatch('loadAllPassportsCoordinates')
      commit('setLoadingStatus', true)
      return houseApi.getHousesList(state.currentPage, rootState.countHousesOnPage.countHousesOnPage)
        .then(response => {
          commit('setLoadingStatus', false)
          commit('setHousesList', response)
          return response
        })
    },

    searchHouses({state, commit, dispatch, rootState}, input = state.searchInput) {
      if (input) {
        if (input !== state.searchInput) {
          commit('setSearchInput', input)
        }
        commit('setLoadingStatus', true)
        dispatch('loadAllPassportsCoordinates', input)
        return houseApi.searchHouses(input, state.currentPage, rootState.countHousesOnPage.countHousesOnPage)
          .then(response => {
            commit('setLoadingStatus', false)
            commit('setSearchHousesList', response)
            return response
          })
      } else {
        commit('clearSearch')
      }
    },

    reloadOrResearchHouses({state, dispatch}) {
      if (state.searchInput) {
        dispatch('searchHouses')
      } else {
        dispatch('loadHousesList')
      }
    },

    loadAllPassportsCoordinates({commit}, search = undefined) {
      houseApi.loadAllPassportsCoordinates(search).then(response => commit('setAllPassportsCoordinates', response))
    }
  }
}
